declare global {
	interface Window {
		googletag: {
			cmd: {
				push: (callback: () => void) => void
			}
			pubads: () => {
				addEventListener: (
					event: string,
					callback: (event: {
						slot: {
							getSlotElementId: () => string
						}
					}) => void
				) => void
			}
		}
	}
}

/**
 * Render a callback function after each ad slots rendering
 * @param options Otions
 * @param [options.callback] Callback function executed after each slots rendering
 * @see https://developers.google.com/doubleclick-gpt/reference#googletag.events.slotrenderendedevent
 */
export default function checkWhenSlotRenderEnded({
	callback = false
}: {
	callback?: boolean | ((event: object, slotElementId: string) => void)
} = {}): void {
	window.googletag = window.googletag || {}
	window.googletag.cmd = window.googletag.cmd || []
	window.googletag.cmd.push(() => {
		window.googletag.pubads().addEventListener(
			'slotRenderEnded',
			(event: {
				slot: {
					getSlotElementId: () => string
				}
			}) => {
				if (callback && typeof callback === 'function') {
					callback(event, event.slot.getSlotElementId())
				}
			}
		)
	})
}
